// The bearer token lives in sessionStorage: it dies with the tab, and the service issues
// short-lived tokens anyway (300 s on stage). Nothing else is persisted client-side.
const KEY = 'candidate-web.token';

export function readToken(): string | undefined {
  try {
    return window.sessionStorage.getItem(KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function writeToken(token: string): void {
  window.sessionStorage.setItem(KEY, token);
}

export function clearToken(): void {
  window.sessionStorage.removeItem(KEY);
}
